const sales_calculatedMetrics = {
  SalesPerCap: {
    numerator: 'SalesRevenues',
    denominator: 'SalesUnits',
  },
  SalesRawPerCap: {
    numerator: 'SalesRevenues_Raw',
    denominator: 'SalesUnits',
  },
  SalesPerCap_AllParks: {
    numerator: 'SalesRevenues',
    denominator: 'SalesUnits_AllParks',
  },
  SalesRawPerCap_AllParks: {
    numerator: 'SalesRevenues_Raw',
    denominator: 'SalesUnits_AllParks',
  },
};

const sales_metrics = {
  SalesUnits: {
    fieldName: 'SalesUnits',
    displayName: 'Sales Units',
    chartFormat: ',',
    format: {
      style: 'decimal',
      maximumFractionDigits: 0,
    },
  },
  SalesPerCap: {
    fieldName: 'SalesPerCap',
    displayName: 'Sales Per Cap',
    chartFormat: '$.2f',
    format: {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
      // minimumFractionDigits: 2,
    },
  },
  SalesRevenues: {
    fieldName: 'SalesRevenues',
    displayName: 'Sales Revenues',
    chartFormat: '$~s',
    format: {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
      // maximumSignificantDigits: 3,
    },
  },
  SalesRawPerCap: {
    fieldName: 'SalesRawPerCap',
    displayName: 'Sales Raw Per Cap',
    chartFormat: '$.2f',
    format: {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
      // minimumFractionDigits: 2,
    },
  },
  SalesUnits_AllParks: {
    fieldName: 'SalesUnits_AllParks',
    displayName: 'Sales Units All Parks',
    chartFormat: ',',
    format: {
      style: 'decimal',
      maximumFractionDigits: 0,
    },
  },
  SalesPerCap_AllParks: {
    fieldName: 'SalesPerCap_AllParks',
    displayName: 'Sales Per Cap All Parks',
    chartFormat: '$.2f',
    format: {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
      // minimumFractionDigits: 2,
    },
  },
  SalesRawPerCap_AllParks: {
    fieldName: 'SalesRawPerCap_AllParks',
    displayName: 'Sales Raw Per Cap All Parks',
    chartFormat: '$.2f',
    format: {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
      // minimumFractionDigits: 2,
    },
  },
};

const sales_filterDimensions = {
  Park: {
    order: 'asc',
    customOrder: ['SWF', 'APO', 'BGT', 'AIT', 'SWC', 'SPC', 'SWT', 'APT', 'BGW', 'WCW', 'SPL'],
  },
  Date: {
    // order: 'desc',
    sortType: 'alpha',
  },
  Year: {
    // order: 'desc',// Gets overridden by the getFilterValues special case
    sortType: 'alpha',
  },
  YearMonth: {
    // order: 'desc',// Gets overridden by the getFilterValues special case
    sortType: 'alpha',
  },
  ProductCategory: {
    order: 'desc',
    customOrder: ['Discrete', 'Pass', 'Free'],
  },
  ProductType: {
    order: 'desc',
    customOrder: ['SDT', 'MDT', 'FC', 'Fun Card', 'Pass', 'Free'],
  },
  ProductFamily: {
    order: 'desc',
  },
  PassTier: {
    order: 'desc',
    customOrder: ['Adjustments', 'Season Pass', 'Bronze', 'Silver', 'Gold', 'Platinum', 'Dimaond'],
  },
};

export default { sales_calculatedMetrics, sales_metrics, sales_filterDimensions };
